import React from "react";
import { Card, Form, Row, Col, Button, Image } from "react-bootstrap";
import { useUploadFile } from "../../../../../../api/fileUpload/fileUpload.hooks";

const StrategicObjectivesSection = ({ data, onUpdate }) => {
  const { upload, isLoading: isUploading } = useUploadFile();

  const handleChange = (field, value) => {
    onUpdate({
      ...data,
      [field]: value
    });
  };

  const handleFileUpload = async (field, file) => {
    try {
      const res = await upload(file);
      if (res?.url) {
        handleChange(field, res.url);
      }
    } catch (err) {
      console.error("File upload failed:", err);
    }
  };

  const handleObjectivesChange = (index, field, value) => {
    const objectives = [...data.objectives];
    objectives[index][field] = value;
    handleChange("objectives", objectives);
  };

  const handleAddObjective = () => {
    const objectives = [...data.objectives];
    objectives.push({ id: Date.now().toString(), title: "" });
    handleChange("objectives", objectives);
  };

  const handleRemoveObjective = (index) => {
    const objectives = [...data.objectives];
    objectives.splice(index, 1);
    handleChange("objectives", objectives);
  };

  return (
    <Card className="mb-4 shadow">
      <Card.Header className="bg-neutral-gray text-dark d-flex justify-content-between align-items-center">
        <h5 className="mb-0 text-dark">Strategic Objectives Section</h5>
        <Form.Check
          type="checkbox"
          label="Visible"
          checked={data.isVisible}
          onChange={(e) => handleChange('isVisible', e.target.checked)}
          className="mb-0"
        />
      </Card.Header>
      {data.isVisible && (
        <Card.Body>
          <Row>
            <Col md={12}>
              <Form.Group className="mb-3">
                <Form.Label>Heading</Form.Label>
                <Form.Control
                  type="text"
                  value={data.heading}
                  onChange={(e) => handleChange('heading', e.target.value)}
                  placeholder="Enter heading"
                />
              </Form.Group>
            </Col>
            <Col md={12}>
              <Form.Group className="mb-3">
                <Form.Label>Background Image</Form.Label>
                <Form.Control
                  type="file"
                  accept="image/*"
                  onChange={(e) =>
                    e.target.files?.[0] && handleFileUpload('backgroundImage', e.target.files[0])
                  }
                />
                {isUploading && (
                  <div className="text-muted small mt-1">Uploading...</div>
                )}
                {data.backgroundImage && (
                  <div className="mt-2">
                    <Image src={data.backgroundImage} thumbnail style={{ maxWidth: "200px" }} />
                  </div>
                )}
              </Form.Group>
            </Col>
          </Row>

          <div className="d-flex justify-content-between align-items-center mb-3">
            <h6>Objectives</h6>
            <Button variant="outline-primary" size="sm" onClick={handleAddObjective}>
              Add Objective
            </Button>
          </div>

          {data.objectives.map((objective, index) => (
            <div key={index} className="border rounded p-3 mb-3 bg-light-subtle">
              <Row>
                <Col md={10}>
                  <Form.Control
                    type="text"
                    placeholder="Objective title"
                    value={objective.title}
                    onChange={(e) => handleObjectivesChange(index, 'title', e.target.value)}
                  />
                </Col>
                <Col md={2}>
                  <Button
                    variant="outline-danger"
                    size="sm"
                    onClick={() => handleRemoveObjective(index)}
                  >
                    Remove
                  </Button>
                </Col>
              </Row>
            </div>
          ))}
        </Card.Body>
      )}
    </Card>
  );
};

export default StrategicObjectivesSection;
